import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiOutlineMail } from "react-icons/ai";


function Home2() {
  const pillars = [
    {
      title: "Human Physiological Needs",
      description: "Hunger, shelter, clothing, safety, and essential survival resources"
    },
    {
      title: "Entrepreneurial Business Preparation",
      description: "Budgeting, debt management, business proposal development, coaching, organizational analysis, managerial development, financial management"
    },
    {
      title: "Career Education and Vocational Preparation",
      description: "STEM focus, vocational training, interviewing skills, preparation for in-demand jobs, and leadership development"
    },
    {
      title: "Life, Financial, and Survival Skills",
      description: "Generational wealth focus, financial, moral, and life skills"
    }
  ];

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <div className="section-shell">
        <Row className="align-items-center gy-5">
          <Col md={12} className="home-about-description">
            <span className="section-eyebrow">Mission</span>
            <h2 className="section-title">Resourcing Trusted Institutions Already Serving the Community</h2>
            <p className="home-about-body">
              The <b className="purple">Shared Success Foundation</b> is a private non-operating
              foundation that directs funds and practical resources to churches 
              that are already serving their communities with compassion and Christ-like love
            </p>
            <p className="home-about-body">
              Guided by <i>Matthew 25:35-40</i>, we partner with churches that are already close to
              the work and close to the people, helping them extend outreach from immediate support
              to long-term self-actualization
            </p>

            <div className="mission-pillars">
              {pillars.map((pillar) => (
                <div className="mission-pillar" key={pillar.title}>
                  <strong>{pillar.title}</strong>
                  <span>{pillar.description}</span>
                </div>
              ))}
            </div>
          </Col>
        </Row>

        <div className="contact-panel">
          <div className="info-card">
            <h3>How We Partner</h3>
            <p>
              We look for partners that represent the compassion of Christ in actions
              and programs that address their neighbor’s and neighborhood’s
              immediate and long-term needs
            </p>
          </div>
          <div className="info-card home-about-social">
            <h3>Contact Us</h3>
            <p>Reach the foundation team with partnership questions or donor inquiries</p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="mailto:shared.success.foundation@gmail.com"
                  className="icon-colour home-social-icons"
                  aria-label="Email Shared Success Foundation"
                >
                  <AiOutlineMail />
                </a>
              </li>
            </ul>
          </div>
        </div>
        </div>
      </Container>
    </Container>
  );
}

export default Home2;
